<<template>
    <router-link :exact-active-class="exactActiveClass" :active-class="activeClass" :class="classes" :to="to">
        <slot></slot>
    </router-link>
</template>
<script>
    import theme from './theme.scss';

    export default {
        name: 'app-router-link',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                },
            },
            to: [String, Object],
            activeClass: String,
            exactActiveClass: String,
            disabled: Boolean,
            size: {
                type: String,
                default: 'text',
            },
        },
        computed: {
            classes() {
                return {
                    [this.theme.link]: true,
                    [this.theme['is-' + this.size]]: true,
                    [this.theme.isDisabled]: this.disabled,
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// RouterLink.vue?d8a65916